module.exports = function (svg) {
  $(svg).find('use').each(function () {
    replaceWithGroup(svg, this);
    $(this).remove();
  });

  return svg;
};

function replaceWithGroup (svg, useNode) {
  var editor = INKIVE.Tool.getInstance().editor;
  var group = document.createElementNS(svgedit.NS.SVG, 'g');
  var originalNode = $(svg).find(useNode.getAttribute('xlink:href'))[0];

  if (originalNode) {
    cloneOriginalContent();
    cloneUseAttributes();

    useNode.parentElement.insertBefore(group, useNode);
  }

  function cloneOriginalContent () {
    var len = originalNode.childNodes.length;

    for (var i = len - 1; i >= 0; i--) {
      var elem = originalNode.childNodes[i].cloneNode(true);
      group.insertBefore(elem, group.firstChild);
    }
  }

  function cloneUseAttributes () {
    _.chain(useNode.getAttributeNames())
      .without(useNode.getAttributeNames(), 'xlink:href')
      .each(function (attName) {
        group.setAttribute(attName, useNode.getAttribute(attName));
      });
  }
}
